import { getTokenValue } from '@atlaskit/tokens';
import type { ConfigType } from '../../../common/types';
import type { Operation } from './types';

export const BACKGROUND_PATTERN_OPTIONS = [
	{ value: 'none', label: 'None' },
	{ value: 'diamond', label: 'Diamond' },
	{ value: 'hexagon', label: 'Hexagon' },
	{ value: 'circle', label: 'Circle' },
];

export const LIMITS = {
	HEADER_TEXT_MAX_LENGTH: 25,
	CONFIRMATION_TEXT_MAX_LENGTH: 76,
	WIDGET_BUTTON_CUSTOM_TEXT_MAX_LENGTH: 20,
};

export const DEFAULT_CONFIG: ConfigType = {
	widgetEnabled: true,
	requestTypeId: null,
	rtSearchEnabled: false,
	kbEnabled: false,
	primaryColorHex: getTokenValue('color.text.brand', '#0C66E4'),
	backgroundPattern: 'none',
	widgetType: 'BASIC',
	widgetButtonTextEnabled: false,
	widgetButtonText: 'Contact us',
	headerText: 'Contact us',
	confirmationText: 'Thanks, we’ll get back to you.',
};

export const HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export const SUBMIT_UPDATED: Operation = 'updated';
export const SUBMIT_CREATED: Operation = 'created';

export const ANALYTIC_SCREEN_NAME = 'viewWidgetSettingsScreen';
